module.exports = __webpack_public_path__ + "static/media/traffic-light-slow.8a46089a.svg";